import React, { useEffect, useState } from "react";

const taglines = ["Discipline", "Respect", "Courage", "Wolves Bruxelles"];

export default function Hero({ headerSlides, social }) {
  const [index, setIndex] = useState(0);
  const [slideIndex, setSlideIndex] = useState(0);

  // Tagline rotation
  useEffect(() => {
	const id = setInterval(() => {
	  setIndex((i) => (i + 1) % taglines.length);
	}, 2200);
	return () => clearInterval(id);
  }, []);

  // Slide rotation
  useEffect(() => {
	if (!headerSlides?.length) return;
	const id = setInterval(() => {
	  setSlideIndex((i) => (i + 1) % headerSlides.length);
	}, 5000);
	return () => clearInterval(id);
  }, [headerSlides]);

  const goToInscription = () => {
	document.querySelector("#inscription")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
	<header className="hero">
	  {/* Grain animé */}
	  <div className="hero-grain" aria-hidden="true" />

	  {/* Background slide */}
	  {headerSlides?.length ? (
		headerSlides.map((src, i) => (
		  <div
			key={i}
			className={`hero-bg ${i === slideIndex ? "is-active" : ""}`}
			style={{ backgroundImage: `url(${src})` }}
			aria-hidden="true"
		  />
		))
	  ) : (
		<div className="hero-bg" aria-hidden="true" />
	  )}

	  <div className="hero-overlay" aria-hidden="true" />

	  <div className="hero-content container">
		<div className="hero-center">

		  {/* Eyebrow */}
		  <div className="hero-eyebrow">
			<span>🐺</span> Club de Judo · Bruxelles
		  </div>

		  {/* Tagline rotative */}
		  <div className="tagline-wrap" aria-live="polite">
			<span key={index} className="tagline">
			  {taglines[index]}
			</span>
		  </div>

		  {/* Sous-titre */}
		  <p className="hero-sub">
			Rejoins la meute. Forge ta technique, gagne en confiance,<br />
			progresse à chaque séance — dès 5 ans.
		  </p>

		  {/* CTA */}
		  <div className="hero-actions">
			<button type="button" className="hero-cta" onClick={goToInscription}>
			  Essai gratuit 🥋
			</button>
			<a href="#apropos" className="btn-ghost">
			  Découvrir le club
			</a>
		  </div>

		  {/* Social icons */}
		  {social && (
			<div className="hero-social">
			  <a href={social.fb} target="_blank" rel="noreferrer" aria-label="Facebook">
				<i className="fa-brands fa-facebook-f" />
			  </a>
			  <a href={social.ig} target="_blank" rel="noreferrer" aria-label="Instagram">
				<i className="fa-brands fa-instagram" />
			  </a>
			  <a href={social.tt} target="_blank" rel="noreferrer" aria-label="TikTok">
				<i className="fa-brands fa-tiktok" />
			  </a>
			  <a href={social.wa} target="_blank" rel="noreferrer" aria-label="WhatsApp">
				<i className="fa-brands fa-whatsapp" />
			  </a>
			</div>
		  )}
		</div>
	  </div>

	  {/* Scroll indicator */}
	  <div className="hero-scroll" aria-hidden="true">
		<div className="hero-scroll-line" />
		<span>Scroll</span>
	  </div>

	  {/* Slide dots */}
	  {headerSlides?.length > 1 && (
		<div className="hero-counter" aria-hidden="true">
		  {headerSlides.map((_, i) => (
			<button
			  key={i}
			  className={`hero-dot ${i === slideIndex ? "active" : ""}`}
			  onClick={() => setSlideIndex(i)}
			  aria-label={`Slide ${i + 1}`}
			/>
		  ))}
		</div>
	  )}
	</header>
  );
}
